import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Button from "react-bootstrap/Button";
import ModalOrganizacion from "./modalOrganizacion";
import Col from "react-bootstrap/Col";
import { PageTitle } from "../../../../_metronic/layout/core";
import { Link } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL
const auth = JSON.parse(localStorage.getItem("kt-auth-react-v"));
class OrganizacionIndex extends Component {

    constructor() {
        super();
        this.state = { data: [] };
        this.refreshTable = this.refreshTable.bind(this);
    }

    async componentDidMount() {
        await this.refreshTable();
    }

    async refreshTable() {
        try {
            const response = await fetch(`${API_URL}/organizacion/getAll`,{
                headers: {
                    'auth-token': auth.api_token
                }
            }
            );
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            this.setState({ data: data });
        } catch (err) {
            console.log(err.message);
        };
    }

    async deleteOrg(idOrg){
        await console.log(`eliminando: ${idOrg}`);

        try {
            const response = await fetch(`${API_URL}/organizacion/delete`, {
              method: 'POST',
              body: JSON.stringify({id: idOrg}),
              headers: {
                'Content-Type': 'application/json',
                'auth-token': auth.api_token
              }
            });
            const jsonResponse = await response.json();
            if (response.status >= 200 && response.status < 300) {
              console.log(jsonResponse);
              this.refreshTable();
            }
            else {
              console.log(jsonResponse);
            }
          } catch (err) {
            console.log("se murio");
          }
    }

    render() {
        var moment = require('moment');
        return (
            <>
            <PageTitle>Organizaciones</PageTitle>
                <Container fluid>
                    <Row>
                        <Col>
                            <Form>
                                <Form.Group controlId="formSearch">
                                    <FloatingLabel
                                        controlId="buscaOrganizacion"
                                        label="Buscar Organización"
                                        className="mb-3"
                                    >
                                        <Form.Control type="text" placeholder="Buscar Organización" />
                                    </FloatingLabel>
                                </Form.Group>
                            </Form>
                        </Col>
                        <Col>
                            <ModalOrganizacion action="insert" refreshTable={this.refreshTable}>Agregar Nueva Organización</ModalOrganizacion>
                        </Col>
                    </Row>
                    <Row>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Tipo</th>
                                    <th>Fecha de Termino</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.data.map(post =>
                                        <tr key={post._id}>
                                            <td>{post.nombre}</td>
                                            <td>{post.tipoOrganizacion}</td>
                                            <td>{moment(post.anioTermino).format('YYYY-MM-DD')}</td>
                                            <td>
                                                <ModalOrganizacion item={post} titulo="Editar Ogranizacion" action="update" refreshTable={this.refreshTable}>Editar</ModalOrganizacion>
                                                {' '}
                                                <Link to={`/Organizacion/detalles/${post._id}`}><Button>Detalles</Button></Link>{' '}
                                                <Button onClick={() => { this.deleteOrg(post._id) }}>Eliminar</Button></td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </Row>
                </Container>
            </>
        );
    }

}

export default OrganizacionIndex;